import { BaseContainerModel } from "../base-container.model";
import {
  bl_hc_professional_hdr_RowInterface,
  bl_hc_professional_hdr_RowClass,
} from "../../dbschema/index";


export class HcProfessionalHdrContainerModel extends BaseContainerModel {
  bl_hc_professional_hdr: bl_hc_professional_hdr_RowInterface = new bl_hc_professional_hdr_RowClass();
} 
